var _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _ellipse, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1132.972,
    height: 607.52,
    viewBox: "0 0 1132.972 607.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_171",
    "data-name": "Grupo 171",
    transform: "translate(-142.246 -170.692)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_491",
    "data-name": "Caminho 491",
    d: "M1129.214,413.95c-6.771-12.918-34.285-23.295-46.6-25.646-65.725-12.545-134.567-10.792-201.146-10.582-72.509.228-141.691,11.833-213.6,17.208-37.394,2.785-76.914-2.231-114.4-3.532q-92.582-3.208-185.124-7.529c-53.193-2.482-108.4,3.084-155.322,32.41-5.332,3.337-10.72,7.36-13.147,13.345-15.242,37.574,174.718,32.854,199.467,33.5,124.839,3.249,249.762,4.929,374.616,1.549,92.833-2.515,189.582-2.362,281.648-15.461,20.359-2.9,48.066-3.936,65.655-15.917C1131,426.663,1132.4,420.027,1129.214,413.95Z",
    transform: "translate(81.699 311.687)",
    fill: "#e7f5fe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137",
    transform: "translate(201.691 170.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_492",
    "data-name": "Caminho 492",
    d: "M1095.9,187.489c33.358,0,87.711,13.189,82.336,45.762-7.368,44.637-205.767,28.176-253.153,28.64-95.295.93-191.6,1.289-285.032,22.126-22.718,5.067-55.261,16.25-52.787,45.236.865,10.123,6.831,19.289,14.423,26.143,27.286,24.644,65.307,27.005,100.6,31.33,53.381,6.543,307.3-2.176,390.3,25.037,16.348,5.36,36.77,12.272,37.449,35.621,1.73,59.372-145.725,56.449-189.953,57.578-118.051,3.011-236.234,1.818-354.287-.511-95.4-1.883-191.106-3.55-286.353-9.707-35.506-2.294-93.578-2.983-120.655-29.637-15.142-14.9-17.128-42,6.811-55.843,16.874-9.757,66.372-5.49,85.422-7.127,61.571-5.3,37.437-44.85-16.536-44.85",
    transform: "translate(-167.49 -145.378)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130",
    transform: "translate(842.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_493",
    "data-name": "Caminho 493",
    d: "M593.137,256.218l-15.2-80.351a6.347,6.347,0,0,0-10.379-3.633l-61.987,53.341a6.348,6.348,0,0,0,2.046,10.805L584.8,263.39A6.347,6.347,0,0,0,593.137,256.218Z",
    transform: "translate(-503.36 -170.692)",
    fill: "#f0faff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129",
    transform: "translate(10.64 10.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_494",
    "data-name": "Caminho 494",
    d: "M575.031,248.79a3.937,3.937,0,0,1-1.3-.221l-63.486-22.217a3.947,3.947,0,0,1-1.271-6.714l50.987-43.874a3.941,3.941,0,0,1,6.445,2.256l12.5,66.094a3.942,3.942,0,0,1-3.881,4.676Zm-61.378-26.559,59.987,20.993-11.813-62.449Z",
    transform: "translate(-507.604 -174.81)",
    fill: "#b5ddf7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_495",
    "data-name": "Caminho 495",
    d: "M524.464,210.194h0a2.378,2.378,0,0,1-1.494-2.931l6.295-22.086a3.734,3.734,0,0,1,4.811-2.449h0a3.732,3.732,0,0,1,2.234,4.914l-8.849,21.194A2.38,2.38,0,0,1,524.464,210.194Z",
    transform: "translate(-473.962 -152.872)",
    fill: "#b5ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_496",
    "data-name": "Caminho 496",
    d: "M526.523,197.9a2.425,2.425,0,1,1-1.487-3.089A2.422,2.422,0,0,1,526.523,197.9Z",
    transform: "translate(-475.559 -134.553)",
    fill: "#b5ddf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_132",
    "data-name": "Grupo 132",
    transform: "translate(25.935 159.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_497",
    "data-name": "Caminho 497",
    d: "M234.078,259.671,184.1,234.792a4.335,4.335,0,0,0-6.257,4.149l3.445,55.72a4.335,4.335,0,0,0,6.721,3.344l46.532-30.843A4.332,4.332,0,0,0,234.078,259.671Z",
    transform: "translate(-177.836 -234.331)",
    fill: "#f0faff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131",
    transform: "translate(4.807 6.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_498",
    "data-name": "Caminho 498",
    d: "M225.693,261.675a2.691,2.691,0,0,1-.654.617L186.765,287.66a2.692,2.692,0,0,1-4.174-2.078l-2.833-45.83a2.69,2.69,0,0,1,3.886-2.577l41.107,20.462a2.687,2.687,0,0,1,.943,4.039Zm-39.766,22.432,36.165-23.972L183.253,240.8Z",
    transform: "translate(-179.753 -236.893)",
    fill: "#b5ddf7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_499",
    "data-name": "Caminho 499",
    d: "M194.974,258.53h0a1.627,1.627,0,0,1-2.211-.4L183.344,245.6a2.553,2.553,0,0,1,.652-3.63h0a2.551,2.551,0,0,1,3.6.815l7.877,13.555A1.624,1.624,0,0,1,194.974,258.53Z",
    transform: "translate(-170.272 -223.461)",
    fill: "#b5ddf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_500",
    "data-name": "Caminho 500",
    d: "M190.9,249.655a1.656,1.656,0,1,1-2.294-.464A1.656,1.656,0,0,1,190.9,249.655Z",
    transform: "translate(-162.729 -212.355)",
    fill: "#b5ddf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136",
    transform: "translate(112.633 50.592)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_110",
    "data-name": "Elipse 110",
    cx: 4.163,
    cy: 4.163,
    r: 4.163,
    transform: "translate(0 238.326)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_111",
    "data-name": "Elipse 111",
    cx: 4.163,
    cy: 4.163,
    r: 4.163,
    transform: "translate(617.775 161.316)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_112",
    "data-name": "Elipse 112",
    cx: 4.163,
    cy: 4.163,
    r: 4.163,
    transform: "translate(290.005 44.688)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_113",
    "data-name": "Elipse 113",
    cx: 4.163,
    cy: 4.163,
    r: 4.163,
    transform: "translate(285.01 361.201)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    "data-name": "Grupo 133",
    transform: "translate(381.461 120.3)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_84",
    "data-name": "Linha 84",
    y2: 9.416,
    transform: "translate(4.708)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_85",
    "data-name": "Linha 85",
    x1: 9.416,
    transform: "translate(0 4.708)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134",
    transform: "translate(550.454)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_86",
    "data-name": "Linha 86",
    y2: 9.416,
    transform: "translate(4.708)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_87",
    "data-name": "Linha 87",
    x1: 9.416,
    transform: "translate(0 4.708)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135",
    transform: "translate(811.903 253.985)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_88",
    "data-name": "Linha 88",
    y2: 9.416,
    transform: "translate(4.708)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_89",
    "data-name": "Linha 89",
    x1: 9.416,
    transform: "translate(0 4.708)",
    fill: "none",
    stroke: "#d2e8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151",
    transform: "translate(651.135 244.897)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    transform: "translate(99.602 239.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139",
    transform: "translate(0 2.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_501",
    "data-name": "Caminho 501",
    d: "M410.7,399.552s-17.526,7.476-17.514,11.216c.01,2.146,24.1-.925,25.551-2.377,2.324-2.324-.94-8.516-.94-8.516Z",
    transform: "translate(-376.418 -141.976)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_502",
    "data-name": "Caminho 502",
    d: "M399.725,397.012l1.123,10.775a3.288,3.288,0,0,0,3.033,1.935,5.1,5.1,0,0,0,4.064-1.935L407.08,394.3",
    transform: "translate(-366.566 -149.888)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_503",
    "data-name": "Caminho 503",
    d: "M450.263,296.808c6.375,25.684,4.009,38.73-5.33,58.106-5.658,65.149-9.612,130.041-17.225,193.563l-8.05.461c-18.291-61.847-35.12-154.3-32.974-238.816",
    transform: "translate(-386.498 -296.808)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    transform: "translate(38.918 8.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_504",
    "data-name": "Caminho 504",
    d: "M422.9,300.328c2.326,5.967,2.913,12.68,2.71,19.025-.311,9.747-4.272,18.572-6.836,27.815-3.422,12.327-3.685,24.6-4.62,37.239q-2.2,29.659-4.47,59.31Q406,492.08,402.245,540.433q-.109,1.436-.223,2.87",
    transform: "translate(-402.022 -300.328)",
    fill: "none",
    stroke: "#0061a6",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141",
    transform: "translate(53.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_505",
    "data-name": "Caminho 505",
    d: "M438.576,400.552s-17.526,7.476-17.514,11.216c.01,2.146,24.1-.925,25.551-2.377,2.324-2.324-.94-8.516-.94-8.516Z",
    transform: "translate(-387.754 -138.293)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_506",
    "data-name": "Caminho 506",
    d: "M427.6,398.012l1.123,10.775a3.288,3.288,0,0,0,3.033,1.935,5.1,5.1,0,0,0,4.064-1.935l-.865-13.485",
    transform: "translate(-377.902 -146.205)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_507",
    "data-name": "Caminho 507",
    d: "M476.477,295.94c8.06,25.208,6.563,38.382-1.472,58.335-1.336,65.379-5.834,133.649-9.226,197.536H457.5c-22.342-60.5-46.276-153.908-49.726-238.378",
    transform: "translate(-407.776 -295.94)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140",
    transform: "translate(41.593 10.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_508",
    "data-name": "Caminho 508",
    d: "M439.124,300.105s9.344,21.866-6.45,52.576c-1.823,28.983-2.76,192.854-2.76,192.854",
    transform: "translate(-416.009 -300.105)",
    fill: "none",
    stroke: "#0061a6",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_509",
    "data-name": "Caminho 509",
    d: "M424.367,302.868a14.441,14.441,0,0,0,6.854,5.327,34.052,34.052,0,0,0,8.544,1.935,60.646,60.646,0,0,0,10.419.536",
    transform: "translate(-424.367 -295.941)",
    fill: "none",
    stroke: "#0061a6",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_510",
    "data-name": "Caminho 510",
    d: "M424.823,304.5a23.784,23.784,0,0,0,10.71,5.277,55.909,55.909,0,0,0,11.961,1.131",
    transform: "translate(-423.68 -293.48)",
    fill: "none",
    stroke: "#0061a6",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143",
    transform: "translate(45.023 67.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_511",
    "data-name": "Caminho 511",
    d: "M445.692,261.038c-27.872,48.5-57.876,92.424-75.665,145.462l-5.3-2.818C366.081,354.44,382.04,282.838,403,238.257",
    transform: "translate(-364.727 -210.39)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_512",
    "data-name": "Caminho 512",
    d: "M421.5,227.141A73.659,73.659,0,0,0,402.74,236.3c-9.542,6.348-16.764,15.789-21.67,26.148s-7.6,21.633-9.331,32.962a87.528,87.528,0,0,0,25.04,7.5,132.184,132.184,0,0,0,27.6,0",
    transform: "translate(-354.16 -227.141)",
    fill: "#d9f0ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(90.126 58.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_513",
    "data-name": "Caminho 513",
    d: "M384.176,261.284c-2.966,52.453-.7,106.413.627,157.44,0,0,18.291,4.866,62.732,4.866,44.273,0,73.266-13.495,73.266-13.495-8.579-52.441-15.4-116.782-36.409-159.952,0,0-23.7-25.569-47.091-26.619-4.7-.211-9.4,1.509-13.879,3.593-3.3,1.534-18.464,5.242-18.464,5.242Z",
    transform: "translate(-382.718 -223.507)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_514",
    "data-name": "Caminho 514",
    d: "M383.9,240.441c-1.161,10.083-1.161,41.212-1.161,41.212",
    transform: "translate(-382.69 -197.988)",
    fill: "none",
    stroke: "#94c1f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148",
    transform: "translate(0 206.602)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_515",
    "data-name": "Caminho 515",
    d: "M400.832,308.267c74.244-8.233,105.385,85.869,122.29,122.375,39.964,86.287,190.74,76.666,259.451,76.666,89.99,0,129.487,30.329,87.483,46.236",
    transform: "translate(-265.295 -244.941)",
    fill: "none",
    stroke: "#b4e8fd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_516",
    "data-name": "Caminho 516",
    d: "M467.626,346.472c0,38.194-28.908,61.243-53.614,61.243H373.487V285.227h40.525C438.718,285.227,467.626,308.279,467.626,346.472Z",
    transform: "translate(-306.503 -278.897)",
    fill: "#fdae2b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_517",
    "data-name": "Caminho 517",
    d: "M459.257,350.277c0,37.321-22.1,67.575-49.36,67.575H365.183V282.7H409.9C437.158,282.7,459.257,312.956,459.257,350.277Z",
    transform: "translate(-319.017 -282.702)",
    fill: "#ef8417"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_518",
    "data-name": "Caminho 518",
    d: "M423.638,294.93Q409.134,314.7,395.392,335a6.857,6.857,0,0,0,3.457-1.81c0,1.015-1.619,2.773-.188,3.424s2.946-1.023,4.44-.564c1.4-.328,2.71-2.086,3.735-3.1a7.663,7.663,0,0,0-.627,2.364c9.865-3.836,18.687-13.031,26.361-20.434A61.828,61.828,0,0,0,423.638,294.93Z",
    transform: "translate(-273.493 -264.275)",
    fill: "#fdae2b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_114",
    "data-name": "Elipse 114",
    cx: 49.359,
    cy: 67.575,
    rx: 49.359,
    ry: 67.575,
    transform: "translate(0 0)",
    fill: "#ffc840"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    transform: "translate(36.559 33.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145",
    transform: "translate(0 47.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_519",
    "data-name": "Caminho 519",
    d: "M378.276,325.246c0,5.545-3.788,10.043-8.461,10.043s-8.463-4.5-8.463-10.043,3.79-10.043,8.463-10.043S378.276,319.7,378.276,325.246Z",
    transform: "translate(-361.351 -315.203)",
    fill: "#ef8417"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_520",
    "data-name": "Caminho 520",
    d: "M378.276,306.142c0,5.545-3.788,10.043-8.461,10.043s-8.463-4.5-8.463-10.043,3.79-10.043,8.463-10.043S378.276,300.6,378.276,306.142Z",
    transform: "translate(-361.351 -296.099)",
    fill: "#ef8417"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149",
    transform: "translate(121.321 58.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_521",
    "data-name": "Caminho 521",
    d: "M471.874,261.083s3.134,31.919-11.139,58.463c-12.206,22.7-36.451,52.077-56.041,68.265l-4.706-1.146c6.816-26.163,28.336-72.617,29.675-90.033s1.018-37.6,1.339-47.3",
    transform: "translate(-387.887 -184.61)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_522",
    "data-name": "Caminho 522",
    d: "M404.491,223.514s26.271,1.8,41.51,14.673c21.758,18.386,24.982,54.369,24.982,62.724-6.576,7.107-20.953,7.471-31.43,7.471a36.126,36.126,0,0,1-18.13-5.014l-2.138-39.693",
    transform: "translate(-381.103 -223.514)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_523",
    "data-name": "Caminho 523",
    d: "M409.174,302.56a16.708,16.708,0,0,0-8.4,3.713c-2.3,1.8-5.132,4.808-4.836,6.185.311,1.447,4.084-1.336,4.543-.775s-6.458,11.005-5.154,11.788,7.185-8.679,7.185-8.679-5.713,10.108-3.5,10.329c1.848.186,6.919-9.381,6.919-9.381s-4.289,8.554-2.82,8.877,5.443-8.2,5.443-8.2-3.234,7.28-1.993,7.4c.627.063,3.821-3.557,5.154-7.945,1.314-4.315,2.848-8.06,1.665-11.427",
    transform: "translate(-395.162 -104.394)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_90",
    "data-name": "Linha 90",
    y2: 36.163,
    transform: "translate(41.419 44.332)",
    fill: "none",
    stroke: "#94c1f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    transform: "translate(88.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_524",
    "data-name": "Caminho 524",
    d: "M382.888,211.174c-.138,1.567-.2,3.141-.188,4.713.025,3.409.464,6.982,2.427,9.767a10.27,10.27,0,0,0,5.638,3.956c1.6.436,3.693.251,4.382-1.256a4.088,4.088,0,0,0,.253-1.725,46.335,46.335,0,0,0-3.329-17.065",
    transform: "translate(-380.852 -186.316)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_525",
    "data-name": "Caminho 525",
    d: "M421.245,222.9c-2.251-8.784-9.341-21.089-20.875-18.619-7.243,1.552-13.914,6.485-16.045,13.395-2.545,8.25,1.582,17.845,6.526,24.581a20.369,20.369,0,0,0,6.8,6.308c6.679,3.452,15.691.622,20.224-5.129S423.025,229.858,421.245,222.9Z",
    transform: "translate(-379.568 -194.758)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_526",
    "data-name": "Caminho 526",
    d: "M392.951,227.048l3.771,13.773-5.132,2.422a12.527,12.527,0,0,0,11.655,4.086c15.739-2.271,20.687-13.179,20.687-13.179l-8.885-.928-9.837-16.767",
    transform: "translate(-367.452 -175.931)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_527",
    "data-name": "Caminho 527",
    d: "M431.317,218.853c-1.1-6.039-5.4-11.164-10.65-14.347-9.316-5.658-22.575-6.112-30.868,1.682-4.723,4.437-13.222,20.171-3.066,23.292,3.171.975,6.435-.955,9.2-2.8l8.421-5.631a6.68,6.68,0,0,1,3.292-1.416c1.986-.08,3.633,1.642,4.345,3.495s.762,3.891,1.223,5.821a5.569,5.569,0,0,0,2.108,3.525c1.183.757,3.051.534,3.65-.735.414-.882.12-1.915.1-2.891s.531-2.169,1.5-2.126a1.71,1.71,0,0,1,.943.409c2.452,1.908,1.655,5.733,2.469,8.732.108.394-.715,6.461-.441,6.766C431.372,240.816,432.109,223.18,431.317,218.853Z",
    transform: "translate(-381.962 -200.291)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_528",
    "data-name": "Caminho 528",
    d: "M397.043,212.506a2.167,2.167,0,0,1,2-2.254,4.258,4.258,0,0,1,3.066,1.166,6.79,6.79,0,0,1,2.565,4.941,7.627,7.627,0,0,1-1.4,4.209,4.5,4.5,0,0,1-2.254,1.983,3.563,3.563,0,0,1-3.532-1.126",
    transform: "translate(-359.264 -185.305)",
    fill: "#ffb288"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163",
    "data-name": "Grupo 163",
    transform: "translate(144.795 242.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    transform: "translate(210.514 241.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152",
    transform: "translate(76.393 5.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_529",
    "data-name": "Caminho 529",
    d: "M291.068,399.4s16.907,2.818,17.373,6.531c.266,2.128-23.7,4.665-25.323,3.412-2.6-2.005.589-9.509.589-9.509Z",
    transform: "translate(-224.793 -145.504)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_530",
    "data-name": "Caminho 530",
    d: "M289.732,396.312,291.119,407a3.294,3.294,0,0,1-2.76,2.311,5.1,5.1,0,0,1-4.279-1.4l-1.988-13.339",
    transform: "translate(-224.802 -152.783)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_531",
    "data-name": "Caminho 531",
    d: "M260.974,298.124c-3.021,26.291-3.186,38.926,8.564,56.941,5.568,25.441,14.117,51.481,20.58,77.525-2.783,31.1,16.716,80.644,27.206,116.027l7.581-1.3c10.193-63.682,13.959-161.346,4.811-246.836",
    transform: "translate(-259.239 -298.124)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_532",
    "data-name": "Caminho 532",
    d: "M261.9,312.333s29.086,92.342,29.086,97.356.795,22.249,2.083,33.425c2.362,20.474,20.913,80.822,20.913,80.822",
    transform: "translate(-255.232 -276.712)",
    fill: "none",
    stroke: "#0061a6",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_533",
    "data-name": "Caminho 533",
    d: "M283.018,401.6l-1.173-4.614,9.776-.362.131,4.258Z",
    transform: "translate(-225.173 -149.686)",
    fill: "#0061a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_534",
    "data-name": "Caminho 534",
    d: "M239.964,401.259s13.227,9.557,12.053,12.921c-.672,1.928-22.187-6.044-23.044-7.8-1.371-2.81,4.528-7.864,4.528-7.864Z",
    transform: "translate(-228.767 -141.364)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_535",
    "data-name": "Caminho 535",
    d: "M240.374,398.691l-3.339,9.7a3.13,3.13,0,0,1-3.332.8,4.851,4.851,0,0,1-3.058-3l3.946-12.221",
    transform: "translate(-225.937 -148.208)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_536",
    "data-name": "Caminho 536",
    d: "M246.715,295.94c-8.06,25.208-6.563,38.382,1.474,58.335.486,23.879.727,48.043,1,72.211-17.012,42.586-19.707,80.8-17.554,121.352l8.205,3.041s48.853-85.149,57.838-118.81a556.436,556.436,0,0,0,17.739-118.635",
    transform: "translate(-225.404 -295.94)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_537",
    "data-name": "Caminho 537",
    d: "M247.711,298.124s-8.89,26.012,2.768,51.082c0,7,4.006,65.176,2.422,74.166-.762,4.312-8.747,24.877-14.079,44.9-5.9,22.144-7.147,74.367-7.147,74.367",
    transform: "translate(-224.385 -292.649)",
    fill: "none",
    stroke: "#0061a6",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_538",
    "data-name": "Caminho 538",
    d: "M230.644,399.71l1.3-5.479,10.5,4.883-2.071,4.692Z",
    transform: "translate(-225.938 -147.819)",
    fill: "#0061a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155",
    transform: "translate(332.253 15.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_539",
    "data-name": "Caminho 539",
    d: "M303.11,237.381l-6.581-5.618v-11.64c0-1.805-2.449-12.64-4.655-12.64s-2.71-2.71-3.813-1.607.9,13.345,0,14.247-2.073-5.814-2.908-4.979-.905,5.761-.905,8.28,2.018,7.165,4.014,9.161,10.838,11.55,10.838,11.55Z",
    transform: "translate(-266.897 -205.612)",
    fill: "#ef9467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_540",
    "data-name": "Caminho 540",
    d: "M310.246,216.8l-5.5,6.262s21.733,28.767,28.62,38.4c-6.28-2.2-15.292-7.709-20.5-11.126-10.223-6.7-20.474-10.258-27.564-10.258-15.054,0-7.175,49.623,10.289,56.886,33.13,4.981,70.263,1.83,75.949-9.815C379.96,269.887,331.4,229.232,310.246,216.8Z",
    transform: "translate(-277.327 -188.756)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_541",
    "data-name": "Caminho 541",
    d: "M299.679,234.612s4.144,11.575,11.512,15.353",
    transform: "translate(-243.643 -161.909)",
    fill: "none",
    stroke: "#94c1f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156",
    transform: "translate(225.261 63.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_542",
    "data-name": "Caminho 542",
    d: "M273.542,240.963c-39.492,44.353-38.893,120.613-38.893,172.447,0,0,28.993,19.792,73.266,19.792,44.441,0,62.732-10.913,62.732-10.913,1.331-52.516-8.035-75.166.627-162.035,0,0-14.132-32.425-21.665-32.425s-37-2.906-37-2.906Z",
    transform: "translate(-234.649 -224.923)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    "data-name": "Caminho 543",
    d: "M288.276,260.573s.9-15.172,4.58-18.857",
    transform: "translate(-153.834 -199.617)",
    fill: "none",
    stroke: "#94c1f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    "data-name": "Caminho 544",
    d: "M271.163,223.92c1.469-8.95,7.844-21.733,19.552-20.286,7.353.908,13.046,5.984,17.16,11.931,3.53,5.1,2.2,9.978-2.825,22.889-1.6,2.637-5.052,7.353-7.732,9.05-6.348,4.029-15.576,2-20.6-3.327S270,231,271.163,223.92Z",
    transform: "translate(45.111 -193.271)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_545",
    "data-name": "Caminho 545",
    d: "M278.4,228.991c1.685-.253.013-1.349.757.185.476.98.617,1.266,1.572,1.584.935.313.955,1.171,1.737,1.752,1.218.908,2.251-.326,2.765-1.371a11.782,11.782,0,0,0,.7-6.375c-.176-1.65-.727-4.259.89-5.405,1.321-.938,4.242.421,5.6.815,2.1.609,4.179,1.289,6.27,1.925,5.044,1.534,10.369,2.883,15.676,2.169,4.635-.624,9.426-3.038,11.647-7.335,2.662-5.152-2.66-11.883-8.085-11.891a21.052,21.052,0,0,0-4.157.86,3.21,3.21,0,0,1-1.557.023c-1.183-.348-1.7-1.677-2.372-2.715-2.011-3.126-5.445-4.086-8.987-3.7-4.016.441-7.446,2.369-11.269,3.412-2.026.554-3.78.03-5.8.1a6.158,6.158,0,0,0-5.152,3.364c-1.64-1.717-5.3,2.489-6.207,3.6-4,4.871-5.267,11.888-5.378,18.043-.1,5.385.8,13.217,6.706,15.385,2.5.915,4.069,1.4,4.174-.885-1.1-2.374-1.349-7.082-1.577-9.06s.359-4.34,2.194-5.112",
    transform: "translate(39.435 -199.432)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_546",
    "data-name": "Caminho 546",
    d: "M299.589,228.752,298.3,242.277l4.445,1.259a12.519,12.519,0,0,1-10.1,7.1c-15.764,2.1-26.9-10.01-26.9-10.01l5.262-1.018,7.965-25.112",
    transform: "translate(37.473 -176.726)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    d: "M276.691,212.43a2.165,2.165,0,0,0-2.191-2.071,4.275,4.275,0,0,0-2.953,1.432c-4.407,4.39,1.133,15.087,5.483,9.562",
    transform: "translate(43.78 -182.967)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    d: "M303.052,218.853c-.707,1.657-3.5,2.319-5.034,2.487-7.416.82-13.568-3.974-20.667-4.851-1.406-.173-3.008-.288-4.059.664-.993.9-1.086,2.4-1.111,3.748a46.371,46.371,0,0,0,.088,4.974,9.57,9.57,0,0,0,1.143,4.111c3.2,5.337,13.9,6.237,19.324,5.906a11.331,11.331,0,0,0,6.185-1.853c2.442-1.84,2.971-5.059,3.883-7.889A15.627,15.627,0,0,0,303.052,218.853Z",
    transform: "translate(47.134 -173.906)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_549",
    "data-name": "Caminho 549",
    d: "M289.594,220.5a1.471,1.471,0,0,0-.787-.286c-3.462,0-5.382-.83-8.085-1.04a3.782,3.782,0,0,0-1.376.068,2.818,2.818,0,0,0-1.707,2.254,1.9,1.9,0,0,0,1.176,2.164,12.429,12.429,0,0,0,5.192,1.133c1.557.045,3.582.178,4.864-.87C289.6,223.321,290.682,221.282,289.594,220.5Z",
    transform: "translate(55.33 -169.728)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161",
    "data-name": "Grupo 161",
    transform: "translate(0 172.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_550",
    "data-name": "Caminho 550",
    d: "M457.11,297.961c-86.272-4.513-136.5,40.011-172.171,121.109-46.294,105.242-111,113.648-140.145,113.072",
    transform: "translate(-144.795 -224.251)",
    fill: "none",
    stroke: "#b4e8fd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_551",
    "data-name": "Caminho 551",
    d: "M256.325,341.965c3.174,38.061,33.9,58.628,58.518,56.575l40.385-3.369L345.044,273.109l-40.382,3.367C280.041,278.532,253.149,303.9,256.325,341.965Z",
    transform: "translate(22.891 -261.231)",
    fill: "#fdae2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_552",
    "data-name": "Caminho 552",
    d: "M264.667,345.061c3.1,37.193,27.639,65.5,54.8,63.238l44.559-3.715L352.8,269.9l-44.559,3.715C281.07,275.884,261.564,307.87,264.667,345.061Z",
    transform: "translate(35.359 -266.064)",
    fill: "#ef8417"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_115",
    "data-name": "Elipse 115",
    cx: 49.359,
    cy: 67.575,
    rx: 49.359,
    ry: 67.575,
    transform: "translate(335.786 8.206) rotate(-4.768)",
    fill: "#ffc840"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    transform: "translate(384.447 37.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157",
    transform: "translate(3.981 47.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_553",
    "data-name": "Caminho 553",
    d: "M299.776,312.978c.461,5.525,4.61,9.692,9.268,9.3s8.06-5.184,7.6-10.71-4.61-9.694-9.268-9.3S299.317,307.45,299.776,312.978Z",
    transform: "translate(-299.734 -302.243)",
    fill: "#fdae2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    "data-name": "Caminho 554",
    d: "M298.188,293.94c.461,5.528,4.61,9.692,9.268,9.3s8.06-5.184,7.6-10.71-4.61-9.692-9.268-9.3S297.729,288.412,298.188,293.94Z",
    transform: "translate(-298.146 -283.205)",
    fill: "#fdae2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160",
    "data-name": "Grupo 160",
    transform: "translate(389.984 34.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    "data-name": "Caminho 555",
    d: "M304.692,301.6c5.072-.421,62.983-5.252,62.983-5.252a7.019,7.019,0,0,0,6.37-7.609h0A7.014,7.014,0,0,0,366.5,282.3s-58.164,4.851-62.985,5.255S299.62,302.025,304.692,301.6Z",
    transform: "translate(-300.355 -282.271)",
    fill: "#e2e8ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    "data-name": "Caminho 556",
    d: "M306.28,320.64l62.983-5.252a7.019,7.019,0,0,0,6.37-7.609h0a7.014,7.014,0,0,0-7.541-6.445l-62.985,5.252C300.288,306.989,301.208,321.063,306.28,320.64Z",
    transform: "translate(-297.962 -253.582)",
    fill: "#e2e8ed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162",
    "data-name": "Grupo 162",
    transform: "translate(239.029 63.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    "data-name": "Caminho 557",
    d: "M241.947,261.083S238.814,293,253.086,319.545c12.2,22.7,36.451,52.077,56.041,68.265l4.706-1.146c-6.817-26.163-28.339-72.617-29.678-90.033s-1.015-37.6-1.339-47.3",
    transform: "translate(-237.858 -188.142)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    "data-name": "Caminho 558",
    d: "M304.33,224.923s-27.682,1.6-43.6,13.623c-27.521,20.793-22.121,76.625-14.109,103.926s46.557,68.26,59.006,77.084c2.041,0,8.035-.506,7.819-5.2-6.884-21.284-26.514-77.272-26.514-77.272l3.1-75.53",
    transform: "translate(-240.141 -224.923)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    "data-name": "Caminho 559",
    d: "M272.465,302.56a16.718,16.718,0,0,1,8.4,3.713c2.3,1.8,5.132,4.808,4.836,6.185-.313,1.447-4.084-1.336-4.543-.775s6.455,11.005,5.154,11.788-7.185-8.679-7.185-8.679,5.713,10.108,3.5,10.329c-1.85.186-6.919-9.381-6.919-9.381s4.287,8.554,2.82,8.877-5.445-8.2-5.445-8.2,3.236,7.28,1.993,7.4c-.624.063-3.818-3.557-5.154-7.945-1.314-4.315-2.848-8.06-1.662-11.427",
    transform: "translate(-198.402 -107.927)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    "data-name": "Caminho 560",
    d: "M266.564,330.013c-4.412-12.7-7.759-22.244-7.759-22.244l5.816-63.394",
    transform: "translate(-212.015 -195.609)",
    fill: "none",
    stroke: "#94c1f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    "data-name": "Caminho 561",
    d: "M240.209,250.517c-.158,17.193,1.913,38.372,6.32,53.386,3.856,13.141,14.786,29.447,26.476,43.809",
    transform: "translate(-240.051 -186.354)",
    fill: "none",
    stroke: "#94c1f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    transform: "translate(916.901 240.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    "data-name": "Caminho 562",
    d: "M476.358,227.98l4.447-3.043s2.063-9.682,3.2-11.419c1.206-1.843,3.5-5.646,6.092-7.4,1.086-.732,6.039-3.535,7.29-2.284.614.614-1.474,6.222-2.434,7.18s-3.778,5.255-3.339,6.6,2.785-1.6,3.339-2.153,1.3-1.243,1.564-.526c.434,1.2-2.068,7.942-4.029,9.9s-5.129,3.808-7.34,3.808l-6.909,6.1",
    transform: "translate(-417.246 -191.532)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    "data-name": "Caminho 563",
    d: "M528.46,203.3c7.36,4.337,11.916,12.5,13.681,20.682a8.6,8.6,0,0,0,1.6,4.159,9.18,9.18,0,0,0,3.051,1.833,25.123,25.123,0,0,1,12.916,14.691c.918,2.705.2,6.526,1.266,8.832,1.306,2.83,6.112,3.472,8.7,4.33a19.7,19.7,0,0,1,.384,37.276,12.14,12.14,0,0,1,1.4,10.221,23.743,23.743,0,0,1-5.4,9.1c-9.74,11.018-24.756,16.907-39.45,16.273a36.938,36.938,0,0,1-12.4-2.482c-4.442-1.815-8.343-4.728-12.089-7.729-4.515-3.618-9.023-7.579-11.457-12.826s-2.274-12.119,1.85-16.177c-4.763.993-9.85-1.6-12.532-5.658s-3.166-9.306-2.091-14.054a34.951,34.951,0,0,1,6.493-12.956c2.048-2.738,4.4-5.51,4.833-8.9.724-5.658-2.434-10.712-3.257-16.34-1.276-8.757-.88-16.283,6.618-20.938,2.4-6.237,5.317-11.048,12.221-12.886A30.356,30.356,0,0,1,528.46,203.3Z",
    transform: "translate(-415.739 -198.735)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_564",
    "data-name": "Caminho 564",
    d: "M547.467,249.367c-25.007-6.548-53.634,3.793-60.012,3.765,8.737-8.737,24.774-28.186,30.314-34.907,0-4.618-2.8-5.906-2.8-5.906s-68.593,35.469-61.7,58.63c7.2,24.18,74.4,12.314,79.767,19.256",
    transform: "translate(-452.779 -178.265)",
    fill: "#b6e9fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164",
    "data-name": "Grupo 164",
    transform: "translate(52.524 263.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_565",
    "data-name": "Caminho 565",
    d: "M520.8,336.617c-.075,2.046-9.03,46.083-9.689,50.809-1.918,13.761,5.352,27.567,4.645,48.9-.86,25.937-11.893,95.648-13.295,98.739s-8.128.258-8.128.258-19.389-93.517-20.482-131.786c-.9-31.52,3.678-99.737,3.678-99.737",
    transform: "translate(-473.73 -303.801)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_566",
    "data-name": "Caminho 566",
    d: "M497.4,396.527a11.291,11.291,0,0,1,1.073,3.437c-.143,2.906-.236,4.889-.236,4.889l-1.261.083-.439-2.369a19.993,19.993,0,0,0-6.766,2.83c-1.655,1.088-9.965.99-11.246.313a1.68,1.68,0,0,1-.544-2.677c.479-.557,9.471-4.485,9.471-4.485",
    transform: "translate(-467.99 -164.066)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_567",
    "data-name": "Caminho 567",
    d: "M486.286,397.241c-.727,1.757-7.832,5.628-7.175,6.147s4.783.544,9.366-.98c4.174-1.389,6.536-2.946,6.671-4.039l-.8-2.938",
    transform: "translate(-465.686 -165.718)",
    fill: "#ffb288"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165",
    "data-name": "Grupo 165",
    transform: "translate(116.245 266.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_568",
    "data-name": "Caminho 568",
    d: "M544.725,336.544c-.013,2.048-7.624,46.336-8.138,51.082-1.5,13.811,6.19,27.389,6.135,48.735-.07,25.95-8.972,95.967-10.278,99.1s-8.115.5-8.115.5-22.229-92.883-24.491-131.1c-1.863-31.48.637-99.8.637-99.8",
    transform: "translate(-499.148 -305.064)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_569",
    "data-name": "Caminho 569",
    d: "M524.514,397.435a11.277,11.277,0,0,1,1.176,3.4c-.055,2.911-.088,4.894-.088,4.894l-1.258.123-.509-2.357a20.028,20.028,0,0,0-6.679,3.036c-1.62,1.138-9.93,1.294-11.231.657a1.68,1.68,0,0,1-.624-2.66c.464-.572,9.331-4.771,9.331-4.771",
    transform: "translate(-490.494 -165.864)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_570",
    "data-name": "Caminho 570",
    d: "M513.419,398.4c-.674,1.78-7.656,5.864-6.987,6.363s4.8.4,9.331-1.266c4.131-1.514,6.445-3.141,6.546-4.239l-.887-2.913",
    transform: "translate(-488.239 -167.502)",
    fill: "#ffb288"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_571",
    "data-name": "Caminho 571",
    d: "M567.305,274.443s19.873,13.016,27.446,44.243c10.213,42.109-4.831,124.561-4.831,124.561s-31.127,9.1-64.981,8.812-53.912-11.728-53.977-13.776-5.049-64.469,1.83-106.822c7.721-47.532,27.391-60.345,27.391-60.345",
    transform: "translate(-428.098 -89.66)",
    fill: "#2858ad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167",
    transform: "translate(60.368 69.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166",
    "data-name": "Grupo 166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_572",
    "data-name": "Caminho 572",
    d: "M528.756,227.272c3.081-1.146,11.073,1.655,26.037,7.388,6.573,7.112,9.454,22.7,10.873,36.494-3.881,33.578-8.215,51.912-6.127,63.243.5,2.685,2.956,4.718,2.565,8.461-.812,7.744-13.493,8.92-37.562,11.652S478.8,346.31,480.1,342.9s5.4-6.408,6.054-8.669,2.617-31.029.015-34.446-9.313-13.237-9.313-22.8c0-13.467,7.413-19.509,12.267-26.91,8.085-12.332,14.224-20.063,22.054-22C523.709,224.975,528.756,227.272,528.756,227.272Z",
    transform: "translate(-476.859 -226.452)",
    fill: "#b6e9fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_573",
    "data-name": "Caminho 573",
    d: "M487.126,233.568a17.537,17.537,0,0,1-2.076,10.6c-.905,1.484-6.373,7.052-7.446,10.6",
    transform: "translate(-475.736 -215.728)",
    fill: "none",
    stroke: "#6cb1ef",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    "data-name": "Caminho 574",
    d: "M512.573,244.3c6.571-6.526,7.609-18.91,4.623-27.278-3.364-9.421-16.787-16.481-26.03-10.579C473.02,218.025,491.432,265.294,512.573,244.3Z",
    transform: "translate(-406.067 -190.382)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    "data-name": "Caminho 575",
    d: "M490.274,221.718l.341,20.151s-.755,4.48,7.125,4.761c10.8.386,10.8-7.37,10.8-7.37L502.292,218.5",
    transform: "translate(-396.275 -168.955)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    "data-name": "Caminho 576",
    d: "M510.278,202.281a6.131,6.131,0,0,0-6.892-.168c-1.406.835-2.389,2.214-3.883,2.878a23.429,23.429,0,0,1-3.437.855,19.55,19.55,0,0,0-12.409,10.409c-2.221,5.019-1.509,13.182,2.645,16.767-.18-3.881.985-9.464,3.056-12.75,1.086-1.722,2.8-3.422,4.823-3.194,2.274.256,3.51,2.687,5.149,4.284,2.484,2.417,6.052,2.908,9.333,3.4,3.713.554,6.578,1.208,8.408,4.854a23.98,23.98,0,0,1,1.655,5.044,34.031,34.031,0,0,1,1.133,6.2,15.081,15.081,0,0,0,.414,3.9c.817,2.484,3.347,3.986,5.826,4.823,1.9.642,5.112,1.238,6.307-.92a21.941,21.941,0,0,0,2.2-6.368c1.141-6.769-1.005-13.781-4.655-19.594-4.009-6.378-9.712-10.65-14.859-15.957A32.083,32.083,0,0,0,510.278,202.281Z",
    transform: "translate(-408.109 -195.119)",
    fill: "#26387a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_577",
    "data-name": "Caminho 577",
    d: "M495.551,216.009c.4-1.539,1.534-3.106,3.119-3.347,5.129-.777,4.352,6.884,2.369,9.577-1.153,1.569-4.139,3.623-5.488-.737",
    transform: "translate(-388.323 -177.831)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    transform: "translate(112.265 68.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_578",
    "data-name": "Caminho 578",
    d: "M527.064,276.548l-2.414,5.159s-9.108,2.166-10.073,3.77c-1.527,2.537-3.816,6.042-3.816,8.035s.191,10.74,2.688,10.74c1.567,0,5.235-7.135,5.992-8.133,1.785-2.357,8.99-4.066,8.99-10.274l4.41-9.3",
    transform: "translate(-477.667 -150.117)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_579",
    "data-name": "Caminho 579",
    d: "M497.56,227.512s21.257-5.41,37.865,5.072c12.908,8.145,46.121,48.67,46.126,71.88.005,15.648-31.064,54.409-31.064,54.409l-5.159-3.688s3.006-30.46,12.036-47.249c-6.658-6.661-32.626-27.344-39.149-33.864",
    transform: "translate(-497.56 -226.116)",
    fill: "#b6e9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_580",
    "data-name": "Caminho 580",
    d: "M504.452,244.39c4.643,4.124,16.874,13.969,16.874,13.969",
    transform: "translate(-487.174 -198.578)",
    fill: "none",
    stroke: "#6cb1ef",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170",
    transform: "translate(256.95 172.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_581",
    "data-name": "Caminho 581",
    d: "M352.306,274.106l-25.681-20.7s11.547-42.651-3.74-57.547c-8.135-7.924-18.419-13.332-29.036-17.363-23.631-8.967-51.859-11-72.92,2.973-15.536,10.309-24.979,27.978-29.209,46.138-3.72,15.989-3.409,34.16,6.586,47.181,4.49,5.849,10.637,10.248,17.17,13.67,20.319,10.647,74.066,14.666,97.386-.96,6.458-4.327,5.891-10.178,8.6-19.319Z",
    transform: "translate(-189.532 -171.38)",
    fill: "#e7f5fe"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Oops_",
    "data-name": "Oops!",
    transform: "translate(67.865 78.401)",
    fill: "#94c1f2",
    fontSize: 41,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58.343,
    y: 0
  }, "Oops!"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE404);
export default __webpack_public_path__ + "static/media/e404.a5e1671e4a4cde137eb9a976a7600d6a.svg";
export { ForwardRef as ReactComponent };